import * as React from "react";
import { useParams } from "react-router";
import courseApi from "../../../../api/course";
import BoldTableCell from "../../general/table/BoldTableCell";
import { activityTypeToName } from "../../../../utils/teacher_portal/activityTypeToString";

const TeacherPortalConstructActivityStats = ({ construct }) => {
    const { courseid } = useParams();
    const [stats, setStats] = React.useState(null);
    const [error, setError] = React.useState("");

    React.useEffect(() => {
        let cancelled = false;
        setStats(null);
        setError("");
        courseApi
            .getTeacherConstructActivityStats(courseid, construct.constructid)
            .then((response) => {
                if (!cancelled) setStats(response.data);
            })
            .catch(() => {
                if (!cancelled) setError("Failed to load activity statistics for this topic.");
            });
        return () => {
            cancelled = true;
        };
    }, [courseid, construct.constructid]);

    if (error) return <p className="text-error">{error}</p>;
    if (stats === null) return <p>Loading activity statistics...</p>;
    if (stats.activities.length === 0) return <p>This topic has no learning activities.</p>;

    const total = stats.total_students;
    const rate = (value) => (value === null ? "-" : `${value}%`);

    return (
        <div className="w-full overflow-x-auto">
            <table className="w-full border-collapse text-left">
                <thead>
                    <tr className="border-b border-card_dark">
                        <BoldTableCell>Activity</BoldTableCell>
                        <BoldTableCell>Type</BoldTableCell>
                        <BoldTableCell>Attempt rate</BoldTableCell>
                        <BoldTableCell>Completion rate</BoldTableCell>
                        <BoldTableCell>Success rate</BoldTableCell>
                        <BoldTableCell>Students struggling</BoldTableCell>
                    </tr>
                </thead>
                <tbody>
                    {stats.activities.map((activity) => (
                        <tr key={activity.activityid} className="border-b border-card_dark last:border-0">
                            <td className="px-4 py-2">{activity.activitytitle}</td>
                            <td className="px-4 py-2">{activityTypeToName(activity.activitytype)}</td>
                            <td className="px-4 py-2" title={`${activity.students_attempted} / ${total} students`}>
                                {rate(activity.attempt_rate)}
                            </td>
                            <td className="px-4 py-2" title={`${activity.students_completed} / ${total} students`}>
                                {rate(activity.completion_rate)}
                            </td>
                            <td className={`px-4 py-2 ${activity.success_rate !== null && activity.success_rate < 50 ? "font-semibold text-error" : ""}`}>
                                {rate(activity.success_rate)}
                            </td>
                            <td className={`px-4 py-2 ${activity.students_struggling > 0 ? "font-semibold text-error" : ""}`}>
                                {activity.success_rate === null ? "-" : activity.students_struggling}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TeacherPortalConstructActivityStats;